import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check if hCaptcha widget already exists in this form
    if (this.element.querySelector('.h-captcha')) {
      return
    }

    // The server renders the site key from its configuration (data-hcaptcha-site-key).
    const siteKey = this.element.dataset.hcaptchaSiteKey
    if (!siteKey) {
      console.error('hCaptcha site key is not configured')
      return
    }

    // Create centered wrapper for hCaptcha widget
    const wrapper = document.createElement('div')
    wrapper.classList.add('flex', 'justify-center', 'mt-2', 'hcaptcha-wrapper')
    
    const widgetDiv = document.createElement('div')
    widgetDiv.classList.add('h-captcha')
    widgetDiv.setAttribute('data-sitekey', siteKey)
    
    wrapper.appendChild(widgetDiv)
    
    // Insert before the .actions div or submit button
    const actionsDiv = this.element.querySelector('.actions')
    if (actionsDiv) {
      actionsDiv.parentElement.insertBefore(wrapper, actionsDiv)
    } else {
      const submitButton = this.element.querySelector('[type="submit"]')
      if (submitButton) {
        submitButton.parentElement.insertBefore(wrapper, submitButton)
      } else {
        this.element.appendChild(wrapper)
      }
    }

    // Render hCaptcha - wait for script to load if needed
    this.renderCaptcha(widgetDiv)
  }

  renderCaptcha(widgetDiv) {
    if (typeof hcaptcha !== 'undefined') {
      hcaptcha.render(widgetDiv)
    } else {
      // Script not loaded yet, wait and retry
      window.addEventListener('load', () => {
        if (typeof hcaptcha !== 'undefined') {
          hcaptcha.render(widgetDiv)
        }
      })
      // Also poll in case load already fired
      const checkInterval = setInterval(() => {
        if (typeof hcaptcha !== 'undefined') {
          clearInterval(checkInterval)
          hcaptcha.render(widgetDiv)
        }
      }, 100)
      // Stop polling after 10 seconds
      setTimeout(() => clearInterval(checkInterval), 10000)
    }
  }
}
